import type { ReactNode } from 'react'

import { BullseyeIcon, HouseBlueprintIcon, MoneyRisingIcon, PeopleRisingIcon } from 'components/new-icons'

export type HomeRenovationWorthItItem = {
  id: string
  icon: ReactNode
  title: string
  description: string
}

export const homeRenovationWorthItItems: HomeRenovationWorthItItem[] = [
  {
    id: 'property-value',
    icon: <MoneyRisingIcon color="#FFFFFF" />,
    title: 'Seu imóvel pode valer mais',
    description: 'Reformas bem executadas costumam aumentar o potencial de valorização da propriedade.'
  },
  {
    id: 'family-comfort',
    icon: <PeopleRisingIcon color="#FFFFFF" />,
    title: 'Mais conforto para quem vive nela',
    description: 'Sua casa acompanha as necessidades da sua família.'
  },
  {
    id: 'planned-renovation',
    icon: <HouseBlueprintIcon color="#FFFFFF" />,
    title: 'Menos improviso durante a obra',
    description: 'Sua casa acompanha as necessidades da sua família.'
  },
  {
    id: 'important-plans',
    icon: <BullseyeIcon color="#FFFFFF" />,
    title: 'Realização de planos importantes',
    description: 'Você não precisa deixar seus planos guardados na gaveta.'
  }
]
